module.exports = __webpack_public_path__ + "6acee8f1d64bac27ec519474c65768cd.png";